export default "__VITE_ASSET__BlbeoL5u__"